/* eslint no-use-before-define: ["error", { "variables": false }] */

import React from 'react';
import { StyleSheet, Text, View, Image } from 'react-native';
import { COLOR, FONT, FONT_SIZE, THEME, __WEB__ } from '../../../constants/styles';

export default function FlavorMessage({ currentMessage }) {
  if (!currentMessage.text) return null;

  return (
    <View style={styles.container}>
      <View style={styles.iconContainer}>
        <Image
          style={styles.chatIcon}
          resizeMode="contain"
          source={require('../../../../resources/icon-chat-flavor.png')}
        />
      </View>
      <Text style={styles.text}>{currentMessage.text}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 1,
    borderColor: '#b5b5b5',
    borderRadius: 10,
    marginHorizontal: __WEB__ ? 25 : 10,
    marginVertical: 20,
    paddingVertical: 10,
  },
  iconContainer: {
    borderRightWidth: 1,
    borderColor: '#b5b5b5',
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: __WEB__ ? 20 : 15,
    paddingVertical: __WEB__ ? 20 : 15,
  },
  text: {
    flex: 1,
    ...FONT.bold,
    fontSize: 12,
    color: COLOR.text,
    paddingRight: __WEB__ ? 45 : 20,
    paddingLeft: __WEB__ ? 25 : 20,
  },
  chatIcon: {
    width: __WEB__ ? 40 : 20,
    height: __WEB__ ? 40 : 20,
  },
});
